let language = {
    USER_AUTHORIZE_OR_TEXT: "or",
    USER_AUTHORIZE_FORM_EMAIL_LABEL: "Email",
    USER_AUTHORIZE_FORM_EMAIL_PLACEHOLDER: "Please input your email address",
    USER_AUTHORIZE_FORM_EMAIL_ERROR_TIP1: "Please enter the correct email address",
    USER_AUTHORIZE_FORM_PASSWORD_LABEL: "Password",
    USER_AUTHORIZE_FORM_PASSWORD_PLACEHOLDER: "Please input your password",
    USER_AUTHORIZE_FORM_SUBMIT_BTN: "Sign In",
    USER_AUTHORIZE_FORM_EMAIL_PASS_CONSISTENT_TITLE:"",
    USER_AUTHORIZE_FORM_EMAIL_PASS_CONSISTENT_CONTENT:"Opps, your email and password are the same, which poses a low security risk. You can click [OK] to reset your password now, or click [CANCEL] to reset it later.",
};

export { language }